import type { Props } from '@react-three/fiber';
import { WebGlBenchmarkInner, type WebGlBenchmarkInnerProps } from './WebGlBenchmarkInner';
import { AbyssViewerContextProvider } from '../AbyssViewerContext';

const defaultCanvasProps: Omit<Props, 'children'> = {
  style: {
    background: '#263238',
  },
  gl: { antialias: true, preserveDrawingBuffer: true },
};

export interface WebGlBenchmarkProps extends WebGlBenchmarkInnerProps {
  canvasProps?: Omit<Props, 'children'>;
}

export const WebGlBenchmark = ({ onProgress, onComplete, canvasProps }: WebGlBenchmarkProps) => {
  return (
    <AbyssViewerContextProvider canvasProps={canvasProps ?? defaultCanvasProps}>
      <WebGlBenchmarkInner onComplete={onComplete} onProgress={onProgress} />
    </AbyssViewerContextProvider>
  );
};
WebGlBenchmark.displayName = 'WebGlBenchmark';
